module.exports = __webpack_public_path__ + "public/SiteIcons/shareLink.svg?12165cfc";